import "./style/Loader.css";

const Loader = () => {
  return (
    <div className="page-loader">
      <div className="loader-wrapper">
        <div className="spinner"></div>
        <img
          className="loader-image"
          src="assets/images/brand-logos/desktop-logo.png"
          alt="loader-icon"
        />
      </div>
    </div>
  );
};

export default Loader;
